<template>
  <form :action="action" method="get" ref="search_form">
    <div class="home-form-search form-row mx-0 align-items-center">
      <input v-model="form_data.store_id" name="store_id" type="hidden"/>
      <input name="use_catalog" type="hidden" value="t"/>
      <input v-model="form_data.lodging_sku_id" name="lodging_sku_id" type="hidden"/>

      <!-- CHECK IN -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-input sus_form_checkin">
        <div class="d-flex align-items-center w-100 my-1 bg-white rounded">
          <div class="pl-2 py-1 w-100">
            <div class="input-group date align-items-center w-100">
              <div class="input-group-addon pr-2">
                <i class="fa-solid fa-calendar-days text-lblue fs-24 pt-1"></i>
              </div>
              <input :id='"start_date" + identifier' v-model="form_data.start_date"
                     autocomplete="off" class="form-control border-0 rounded icon" name="start_date"
                     placeholder="Arrive"
                     @change="save_form()"
                     required type="text">
            </div>
          </div>
        </div>
      </div>


      <!-- CHECK OUT -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-input sus_form_checkout">
        <div class="d-flex align-items-center w-100 my-1 bg-white rounded">
          <div class="pl-2 py-1 w-100">
            <div class="input-group date align-items-center w-100">
              <div class="input-group-addon pr-2">
                <i class="fa-solid fa-calendar-days text-lblue fs-24 pt-1"></i>
              </div>
              <input :id='"end_date" + identifier' v-model="form_data.end_date"
                     autocomplete="off" class="form-control border-0 rounded icon" name="end_date"
                     placeholder="Depart"
                     required
                     type="text">
            </div>
          </div>
        </div>
      </div>


      <!-- ADULTS -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-input sus_form_adults">
        <div class="d-flex align-items-center w-100 my-1 bg-white rounded">
          <div class="d-inline pl-2 py-1">
            <i class="fa-solid fa-user text-lblue fs-24 pt-1"></i>
          </div>
          <div class="pl-2 my-1 w-100">
            <input v-model="form_data.adults" class="form-control border-0" name="adults"
                   placeholder="Adults"
                   required type="text" @focus="check_default_adults" onClick="this.select();">
          </div>
        </div>
      </div>


      <!-- CHILDREN -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-input sus_form_children">
        <div class="d-flex align-items-center w-100 my-1 bg-white rounded">
          <div class="d-inline pl-2 py-1">
            <i class="fa-solid fa-children text-lblue fs-24 pt-1"></i>
          </div>
          <div class="pl-2 my-1 w-100">
            <input v-model="form_data.children" class="form-control border-0" name="children"
                   placeholder="Children"
                   type="text" @focus="check_default_children" onClick="this.select();">
          </div>
        </div>
      </div>


      <!-- PETS -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-input sus_form_pets">
        <div class="d-flex align-items-center w-100 my-1 bg-white rounded">
          <div class="d-inline pl-2 py-1">
            <i class="fa-solid fa-dog text-lblue fs-24 pt-1"></i>
          </div>
          <div class="pl-2 my-1 w-100">
            <input v-model="form_data.pets" class="form-control border-0" name="pets"
                   placeholder="Describe Pet(s)"
                   type="text" onClick="this.select();">
          </div>
        </div>
      </div>

      <!-- PROMOTIONS -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-input sus_form_promos">
        <div class="d-flex align-items-center w-100 my-1 bg-white rounded">
          <div class="d-inline pl-2 py-1">
            <i class="fa-solid fa-star text-lblue fs-24 pt-1"></i>
          </div>
          <div class="pl-2 my-1 w-100">
            <input v-model="form_data.promo_code" class="form-control border-0" name="promo_code"
                   placeholder="Promotion Code"
                   type="text" onClick="this.select();">
          </div>
        </div>
      </div>

      <!-- SUBMIT -->
      <div class="col-12 col-sm-12 col-lg-auto col-search-button p-0 sus_form_submit">
        <button class="btn btn-primary btn-lg mw-100 pl-2 opacity-25" type="submit" ref="submitButton">
          <i class="fa-solid fa-magnifying-glass"></i><span class="px-3">Search</span>
        </button>
      </div>

      <!-- CLEAR -->
      <div class="col-12 col-sm-12 col-lg-auto p-0 sus_form_reset">
        <button class="btn btn-danger btn-lg mw-100 pl-2 opacity-25" @click="resetForm">
          <span class="px-3">Reset</span>
        </button>
      </div>

    </div>
  </form>
</template>

<script>

function getRandomInt(max)
{
  return Math.floor(Math.random() * max);
}

export default {
  name: 'App',
  components: {},
  data()
  {
    return {
      action: '',
      form_data: {
        store_id: null,
        sku_id: null,
        start_date: null,
        end_date: null,
        adults: null,
        children: null,
        pets: null,
        promo_code: null,
        min_days: 3,
        lodging_sku_id: null,
      },
      reset_data: {
        store_id: null,
        sku_id: null,
        start_date: null,
        end_date: null,
        adults: null,
        children: null,
        pets: null,
        promo_code: null,
        min_days: 3,
        lodging_sku_id: null,
      },
      default_adults: null,
      default_children: null,
    }
  },
  computed: {
    start_date()
    {
      return this.form_data.start_date
    },
    end_date()
    {
      return this.form_data.end_date
    },
    adults()
    {
      return this.form_data.adults
    },
    children()
    {
      return this.form_data.children
    },
    pets()
    {
      return this.form_data.pets
    },
    promo_code()
    {
      return this.form_data.promo_code
    },
  },
  watch: {
    start_date()
    {
      const parsed = JSON.stringify(this.form_data);
      sessionStorage.setItem('search_form_data', parsed);
    },
    end_date()
    {
      const parsed = JSON.stringify(this.form_data);
      sessionStorage.setItem('search_form_data', parsed);
    },
    adults()
    {
      const parsed = JSON.stringify(this.form_data);
      sessionStorage.setItem('search_form_data', parsed);
    },
    children()
    {
      const parsed = JSON.stringify(this.form_data);
      sessionStorage.setItem('search_form_data', parsed);
    },
    pets()
    {
      const parsed = JSON.stringify(this.form_data);
      sessionStorage.setItem('search_form_data', parsed);
    },
    promo_code()
    {
      const parsed = JSON.stringify(this.form_data);
      sessionStorage.setItem('search_form_data', parsed);
    },
  },
  methods: {
    check_default_adults()
    {
      if (this.default_adults && !this.form_data.adults)
      {
        this.form_data.adults = this.default_adults
      }
    },
    check_default_children()
    {
      if (this.default_children && !this.form_data.children)
      {
        this.form_data.children = this.default_children
      }
    },
    save_form()
    {
      console.log('save_form')
      const parsed = JSON.stringify(this.form_data)
      sessionStorage.setItem('search_form_data', parsed)
    },
    resetForm(event)
    {
      event.preventDefault()
      //this.form_data = JSON.parse(JSON.stringify(this.reset_data))
      sessionStorage.removeItem('search_form_data')
      window.location.href = window.location.href.split('?')[0] + "?reset=t"
    }
  },
  mounted()
  {
    this.identifier = getRandomInt(9999999999).toString()
    this.action = this.$parent.action
    this.default_adults = this.$parent.adults
    this.default_children = this.$parent.children

    const queryString = window.location.search

    if (sessionStorage.getItem('search_form_data'))
    {
        if (!window.location.href.includes('?'))
        {
          this.$refs.search_form.submit()
        }
    }
    else
    {
      const urlParams = new URLSearchParams(queryString)

      this.form_data.start_date = urlParams.get('start_date')
      this.form_data.end_date = urlParams.get('end_date')
      this.form_data.adults = urlParams.get('adults')
      this.form_data.children = urlParams.get('children')
      this.form_data.pets = urlParams.get('pets')
      this.form_data.promo_code = urlParams.get('promo_code')
      if (urlParams.get('reset', '') === 't')
      {
        this.form_data.lodging_sku_id = null
      }
    }

    let vue_form_data = this.form_data
    let start_date = '#start_date' + this.identifier
    let end_date = '#end_date' + this.identifier
    // this get replaced by jquery in the function below
    $(function ()
      {
        let args = {
          startDate: '+1d',
          format: 'yyyy-mm-dd',
          autoclose: true
        }
        $(start_date).datepicker(args).on('changeDate', function (e)
        {
          if (e.target.value)
          {
            vue_form_data.start_date = e.target.value
            var newDate = new Date(e.date)
            newDate.setDate(newDate.getDate() + vue_form_data.min_days)
            $(end_date).datepicker('setStartDate', newDate)
            if (vue_form_data.start_date > vue_form_data.end_date)
            {
              vue_form_data.end_date = null
            }
          }
        }).change();

        args = {
          startDate: '+2d',
          format: 'yyyy-mm-dd',
          autoclose: true
        }
        if (vue_form_data.start_date)
        {
          var newDate = new Date(vue_form_data.start_date)
          newDate.setDate(newDate.getDate() + vue_form_data.min_days)
          args.startDate = newDate
        }
        $(end_date).datepicker(args).on('changeDate', function (e)
        {
          if (e.target.value)
          {
            vue_form_data.end_date = e.target.value
            //var newDate = new Date(e.date)
            //newDate.setDate(newDate.getDate() - vue_form_data.min_days)
            //$('#start_date').datepicker('setEndDate', newDate)
          }
        }).change()
      })
  },
  created()
  {
    this.$set(this.form_data, 'store_id', this.$parent.store_id)
    this.$set(this.form_data, 'lodging_sku_id', this.$parent.lodging_sku_id)

    if (sessionStorage.getItem('search_form_data'))
    {
      try
      {
        const form_data = JSON.parse(sessionStorage.getItem('search_form_data'))
        this.$set(this.form_data, 'start_date', form_data.start_date)
        this.$set(this.form_data, 'end_date', form_data.end_date)
        this.$set(this.form_data, 'adults', form_data.adults)
        this.$set(this.form_data, 'children', form_data.children)
        this.$set(this.form_data, 'pets', form_data.pets)
        this.$set(this.form_data, 'promo_code', form_data.promo_code)
      }
      catch (e)
      {
      }
    }

    if (this.$parent.min_days && parseInt(this.$parent.min_days))
    {
      this.$set(this.form_data, 'min_days', parseInt(this.$parent.min_days))
    }

    let server = window.location.hostname === 'localhost' ? 'http://localhost' : ''

    this.$http.get(
        server + "/ws/get_catalog_min_days",
        {}).then(response =>
                 {
                   if (response.data.min_days)
                   {
                     this.vue_form_data.min_days =
                         response.data.min_days
                   }
                 }).catch(err =>
                          {
                            this.cal_state = 'error'
                          })

  }
}
</script>

<style>
</style>
